import React, { Component } from 'react';
import Parse from 'parse';
import { Link, Redirect} from "react-router-dom";

export default class Units extends Component {
  constructor(props) {
      super(props);
      this.state = {list:[]}
  }

  componentDidMount = () =>{
      if(Parse.User.current().id != "sr6v7szBOQ"){
        this.setState({
          notAdmin:true
        })
      }
      var Query = Parse.Object.extend("Units");
      var query = new Parse.Query(Query);
      query.ascending("unit");
      query.limit(1000);
      query.find({
        success:(results) => {
            this.setState({
              'list':results,
              'fullResults':results
            })
        },
        error: function(error) {
            console.log("Error: " + error.code + " " + error.message);
        }
    })
  }

  search = (value) =>{
    var results = this.state.fullResults;
    var filteredResults = [];
    if(value != ""){
      filteredResults = results.filter(result => result.attributes.unit.toLowerCase().indexOf(value.toLowerCase()) != -1);
    } else{
      filteredResults = results
    }
    this.setState({
      list:filteredResults
    })
  }

  render() {
    if(this.state.notAdmin) return <Redirect to="/" />
    return (
      <div className="max-width-container medium-left-padding">
        <div className="row">
          <div className="small-12 medium-6 left-text">
            <h1 className="uppercase no-margin-top">Units</h1>
          </div>
          <div className="small-12 medium-6 right-text row" style={{justifyContent:'flex-end'}}>
            <Link to={'/newUnit'}>
              <div className="button primary-background white">
                {'+ Add New'}
              </div>
            </Link>
          </div>
        </div>
        <div>
          <input type="text" className="category-search full-width medium-bottom-margin" onChange={(e) => this.search(e.target.value)} placeholder="search..." />
          {this.state.list.map(function(item,index) {
            return (
              <div className="white-background border-bottom" key={item.id}>
                <Link to={'/editUnit?id='+item.id}>
                  <div className="small-padding">
                    <h2 className="black-color" style={{margin:'0px'}}>{item.attributes.unit}</h2>
                    <h4 className="black-color subheading" style={{margin:'0px'}}>{item.attributes.propertyLocation}</h4>
                  </div>
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/units.js